import React from 'react';

import { LoginPage } from '@lumapps/login/components/LoginPage';
import { SendEmailForm } from '@lumapps/login/components/SendEmailForm';
import { StepProps } from '@lumapps/lumx-layouts/types';
import { SIGN_IN } from '@lumapps/sign-in/keys';
import { useTranslate } from '@lumapps/translations';

import { RENEW_PASSWORD_FORM_ID, TITLE_ID } from '../../constants';
import { RESET_PASSWORD } from '../../keys';

/**  RenewPasswordStep: Component which render the step of Renew password
 * where user can fill his email and valid captcha in order to receive the reset link via email */
export const RenewPasswordStep: React.FC<StepProps> = ({ backButton, ...props }) => {
    const { translateKey } = useTranslate();
    return (
        <LoginPage
            title={translateKey(SIGN_IN.FORGOT_YOUR_PASSWORD)}
            subtitle={translateKey(RESET_PASSWORD.LOGIN_RESET_LINK_TEXT)}
            before={backButton}
            displayPoweredBy
        >
            <SendEmailForm
                {...props}
                buttonText={translateKey(RESET_PASSWORD.LOGIN_RESET_LINK_BUTTON)}
                formId={RENEW_PASSWORD_FORM_ID}
                titleId={TITLE_ID}
            />
        </LoginPage>
    );
};
